import axios from './../index';
const {
  get,
  post,
  put,
  del
} = axios;
const branchUrl = "/question";
const externalUrl = "/external";
const saasBusinessUrl = "/saas-business";
const domain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://wxrcc.rel-s.yunduoketang.cn/'; // 获取系统设置

export function querySuebjectLibAuth(params, data) {
  return get(branchUrl + '/v1/config/byGroup/' + params.group, data);
} //配色接口

export function querySystemColor(params) {
  return get(externalUrl + '/api/v1/schools/theme/color?schoolId=' + params.schoolId + '&companyId=' + params.companyId);
} //获取分校列表

export function queryBranchSchoolList(params) {
  return get(branchUrl + '/api/v1/online/school/', params);
} //获取是否开启分校独立状态

export function getSchoolIndepent(params) {
  return get(branchUrl + '/api/v1/online/school/independent/school', params);
} //验证并查询分校配置

export function selectedSchool(params) {
  return get(saasBusinessUrl + '/v1/front/home-page/selected/school', params);
} //查询分校开启的服务

export function integConfig(params) {
  return get(`${saasBusinessUrl}/v1/sys/config/${params.companyId}/${params.code}`);
} //机构已开通服务

export function openServices() {
  return get(`${saasBusinessUrl}/v1/front/home-page/open/services?domain=${domain}`);
} //切换分校

export function saveSessionSchoolId(params) {
  return post(`${saasBusinessUrl}/v1/saveSessionSchoolId?schoolId=${params.schoolId}&domain=${domain}`);
} //获取菜单列表

export function queryMenuList(params) {
  // return get('http://sc.dev-s.yunduoketang.cn/external/api/v1/system/menu', params);
  return get(externalUrl + '/api/v1/system/menu', params);
} //获取每日一练分享相关信息

export function getShareBaseInfo() {
  return get(externalUrl + '/api/v1/share/getBaseInfo');
} //免费用户或付费用户权限

export function getUserAuth(userId) {
  return get(externalUrl + `/api/v1/user/findById?id=${userId}`);
} //考试介绍——证书类考试验证学习进度

export function getStudyOver(params) {
  return get(externalUrl + '/api/v1/classType/study/over', params);
} //获取机构基本信息

export function getBaseInfo(params) {
  return get(externalUrl + '/api/v1/company/getBaseInfo', params);
} //获取当前用户信息

export function getCurrentUser(params) {
  return get(externalUrl + '/api/v1/usersfront/getCurrentUser', params);
} //获取用户配置信息

export function getPersonConfig() {
  return get(externalUrl + '/api/v1/usersfront/getPersonConfig');
} //获取C端机构页尾

export function getSystemFooter(params) {
  return get(externalUrl + '/api/v1/system/get/menu/foot', params);
} //获取机构页头配置

export function headConfig(params) {
  return get(saasBusinessUrl + '/v1/front/home-page/head/config', params);
} //获取代码统计配置

export function getCompanyCodeInfo(params) {
  return get(saasBusinessUrl + '/v1/sysConfigSeo/getCompanyCodeInfo', params);
} // 获取右侧浮窗设置信息

export function getFindMarket(params) {
  return post(`${saasBusinessUrl}/v1/companyMarketSet/findMarket?domain=${domain}&schoolId=${params.schoolId}`);
} // node统计在线人数获取参数

export function getConfigNode(params) {
  return get(`${saasBusinessUrl}/v1/nodeOnline/getConfig`, params);
} // 独立登陆/注册 底部信息

export function getQueryCompanyId() {
  return get(`${saasBusinessUrl}/v1/company/config/companyFootInfo/queryCompanyId?domain=${domain}`);
} // 独立登陆/注册 机构信息

export function getCompanyInfo(params) {
  return get(`${saasBusinessUrl}/v1/company/config/getCompany?domain=${domain}`, params);
} // 快速做题权限控制

export function checkHideSppedTest(params = {}) {
  params.domain = domain;
  return get(`${saasBusinessUrl}/v1/company/config/checkHideSppedTest`, params);
} // 获取课表时区功能是否开启

export function getTimeZoneConfig(params = {}) {
  params.domain = domain;
  return get(`${saasBusinessUrl}/v1/sys/sysConfigTeacherMeetTime/config/timeZone`, params);
}